<template>
  <v-select
      :items="priorities"
      v-model="priority"
      outlined
      hide-details="auto"
      :rules="rules"
      style="max-width: 15em"
  ></v-select>
</template>

<script>
export default {
  name: 'PrioritySelect',
  props: {
    value: {
      required: true,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  computed: {

    priority: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
        this.$emit('change', value);
      },
    },

    priorities() {
      return [
        {
          text: this.$options.filters.priority(1),
          value: 1,
        },
        {
          text: this.$options.filters.priority(2),
          value: 2,
        },
        {
          text: this.$options.filters.priority(3),
          value: 3,
        },
      ];
    },

  },
};
</script>
